import ROUTES from 'src/routes';
import usePaths from 'src/hooks/use-paths';

export const getCustomCategoryLink = (
  baseHref: string,
  customCategory = false,
  slug?: string,
  key?: string
): string | null => {
  if (!baseHref) {
    return null;
  }

  if (customCategory && slug) {
    return `${baseHref}${String(ROUTES.COLLECTIONS)}${slug}`;
  }

  if (!customCategory && key) {
    return `${baseHref}${String(ROUTES.PRODUCTS)}${key}`;
  }

  return null;
};

export const useGetCustomCategoryLink = (customCategory = false, slug?: string, key?: string): string | null => {
  const { href: baseHref } = usePaths();
  return getCustomCategoryLink(baseHref, customCategory, slug, key);
};
